// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1so_p","infoBtn":"quickbooks_infoBtn__2XO2P","formBox":"quickbooks_formBox__-F0ne","formFooter":"quickbooks_formFooter__3JMtm"};